<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-col">
        <div class="footer-brand">湖南瑞祥智航</div>
        <p>湖南瑞祥智航人力资源有限公司</p>
        <p>专注于国内外劳务派遣、人才招聘外包、职业技能培训与全球化人才输送，为制造业、服务业、建筑业、物流仓储及海外项目提供一站式人力资源综合解决方案。
          <br>核心优势：精准人岗匹配 · 合规用工保障 · 全流程服务闭环</p>
      </div>
      <div class="footer-col">
        <h4>快速导航</h4>
        <router-link to="/jobs">找工作</router-link>
        <router-link to="/talents">找人才</router-link>
        <router-link to="/policies">政策文件</router-link>
        <router-link to="/tools">AI助手</router-link>
      </div>
      <div class="footer-col">
        <h4>联系我们</h4>
        <p>邮箱：hnrxzz@126.com</p>
        <p>地址：湖南省长沙湘江新区东方红街道尖山路18号中电软件园二期F7栋905
        </p>
      </div>

    </div>
    <div class="footer-bottom">
      © 2026 湖南瑞祥智航人力资源有限公司　|
      <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener" class="footer-beian">湘ICP备2026015724号-2</a>
    </div>
  </footer>
</template>

<script>
export default { name: 'SiteFooter' }
</script>

<style scoped>
.footer-beian { color: inherit; text-decoration: none; }
.footer-beian:hover { color: #fff; text-decoration: underline; }
</style>
